import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { IsBoolean, IsString, ValidateNested } from 'class-validator';
import { HearingSegment } from '../../type/court';
import { LineItemRequest } from './LineItemRequest';
/**
 * A request for court audio and optional speech to text.
 */
export class AudioLineItemRequest extends LineItemRequest {
    constructor(caseNumber, caseTitle, locationId, hearingSegments, speechToTextAdded, departmentId, distributionList) {
        super(locationId, departmentId, distributionList);
        this.caseNumber = caseNumber;
        this.caseTitle = caseTitle;
        this.hearingSegments = hearingSegments;
        this.speechToTextAdded = speechToTextAdded;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AudioLineItemRequest.prototype, "caseNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AudioLineItemRequest.prototype, "caseTitle", void 0);
__decorate([
    Type(() => HearingSegment),
    ValidateNested(),
    __metadata("design:type", Array)
], AudioLineItemRequest.prototype, "hearingSegments", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], AudioLineItemRequest.prototype, "speechToTextAdded", void 0);
export function isAudioLineItemRequest(lineItemRequest) {
    return lineItemRequest instanceof AudioLineItemRequest;
}
